import React, { Component } from 'react';
import '../styles/Website.css';
import WebsitePurgeDialog from './WebsitePurgeDialog';
import { getWebsites, reinitialiser, deleteCustom, lockQuota, unlockQuota, setAiAutonomous, setGraphdebateMode, getFcmSubscribers } from '../services/websiteService';
import moment from "moment";
import qs from "qs";
import {
  Box,
  Paper,
  Stack,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Switch,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Pagination,
  Avatar,
  Chip,
  Link as MuiLink,
  Collapse,
  IconButton,
  Divider,
  Select,
  MenuItem,
  ListSubheader,
  ListItemIcon,
  FormControl,
  InputLabel,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Grid,
  Dialog,
  AppBar,
  Toolbar,
  Slide,
  LinearProgress,
  Alert,
  Tabs,
  Tab,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Formpub from './Formpub';
import Bills from './Bills';
import ListVip from './ListVip';
import FormVip from './FormVip';
import Tooltip from '@mui/material/Tooltip';
// D14 — régime réellement appliqué + mode en clair dans l'onglet « Modération » de la fiche,
// pour que cette page et le dashboard Modération IA ne se contredisent plus sur le même site.
import { configRegime, modeLabel, regimeLabel, REGIME_APPLIED } from '../lib/moderationModes';
import { websiteActivity, ACTIVE_WINDOW_DAYS } from '../lib/websiteActivity';
import { websiteAddress } from '../lib/websiteAddress';
import Groups2Icon from '@mui/icons-material/Groups2';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import LayersIcon from '@mui/icons-material/Layers';
import ForumIcon from '@mui/icons-material/Forum';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import CampaignIcon from '@mui/icons-material/Campaign';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import TableChartIcon from '@mui/icons-material/TableChart';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LinkIcon from '@mui/icons-material/Link';
import RefreshIcon from '@mui/icons-material/Refresh';
import CircularProgress from '@mui/material/CircularProgress';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Website extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hits: [],
      page: 1,
      pageSize: 30,
      total_elem: 0,
      isLoading: false,
      q: '',
      unpaid: false,
      expert: false,
      custom: false,
      free: false,
      locked: false,
      owner: '',
      expanded: {}, // map { [websiteId]: boolean }
      actionSelection: {}, // { [websiteId]: current value }
      iframeOpen: false,
      iframeUrl: '',
      iframeLoading: false,
      iframeKey: 0,
      // Non-fullscreen iframe popin
      smallIframeOpen: false,
      smallIframeUrl: '',
      smallIframeLoading: false,
      smallIframeKey: 0,
      appBarHeight: 64,
      viewportHeight: 0,
      // FCM subscribers cache and states per website
      fcmSubs: {}, // { [websiteId]: { count: number, users: string[] } }
      fcmLoading: {}, // { [websiteId]: boolean }
      fcmError: {}, // { [websiteId]: string }
      errorMsg: '',
      // Memoization of last fetch parameters to prevent loops
      lastFetchKey: '',
      // Popin state
      modalOpen: false,
      modalWebsite: null,
      modalTab: 'identity',
      purgeWebsiteId: null,
      // Erreur dédiée au toggle « Modération IA débloquée » (onglet Moderation) :
      // errorMsg est rendu hors popin (l.696) donc invisible ici → état séparé.
      // Erreur dédiée au switch « Modération autonome (Full AI) » (onglet Moderation, B4_01).
      aiAutonomousError: '',
      // Erreur dédiée au sélecteur de mode GraphDebate (onglet GraphDebate, B0_02).
      graphdebateModeError: ''
    };
    this.appBarRef = React.createRef();
    this.fetchPage = this.fetchPage.bind(this);
    this.updateViewportHeight = this.updateViewportHeight.bind(this);
    this.onSearchSubmit = this.onSearchSubmit.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onOwnerFilter = this.onOwnerFilter.bind(this);
    this.deleteReset = this.deleteReset.bind(this);
    this.deleteCancel = this.deleteCancel.bind(this);
    this.toggleExpand = this.toggleExpand.bind(this);
    this.handleActionChange = this.handleActionChange.bind(this);
    this.openFullscreenFrame = this.openFullscreenFrame.bind(this);
    this.closeFullscreenFrame = this.closeFullscreenFrame.bind(this);
    this.fetchFcmForWebsite = this.fetchFcmForWebsite.bind(this);
    this.openWebsitePopin = this.openWebsitePopin.bind(this);
    this.closeWebsitePopin = this.closeWebsitePopin.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    // Small iframe popin handlers
    this.openSmallIframe = this.openSmallIframe.bind(this);
    this.closeSmallIframe = this.closeSmallIframe.bind(this);
    this.handleSmallIframeLoad = this.handleSmallIframeLoad.bind(this);
    this.reloadSmallIframe = this.reloadSmallIframe.bind(this);
  }

  async fetchFcmForWebsite(websiteId) {
    if (!websiteId) return;
    this.setState((prev) => ({ fcmLoading: { ...prev.fcmLoading, [websiteId]: true }, fcmError: { ...prev.fcmError, [websiteId]: '' } }));
    try {
      const data = await getFcmSubscribers(websiteId);
      if (!this._isMounted) return;
      this.setState((prev) => ({
        fcmSubs: { ...prev.fcmSubs, [websiteId]: { count: data?.count || 0, users: Array.isArray(data?.users) ? data.users : [] } },
        fcmLoading: { ...prev.fcmLoading, [websiteId]: false }
      }));
    } catch (e) {
      const msg = e?.message || 'Erreur lors du chargement des abonnés FCM';
      this.setState((prev) => ({ fcmError: { ...prev.fcmError, [websiteId]: msg }, fcmLoading: { ...prev.fcmLoading, [websiteId]: false } }));
    }
  }

  componentDidMount() {
    const parsed = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    this._isMounted = true;
    this.setState(
      {
        q: parsed.website_id || '',
        owner: parsed.owner || ''
      },
      () => this.fetchPage(1)
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onSearchSubmit(e) {
    e.preventDefault();
    this.fetchPage(1);
  }

  onPageChange(e, value) {
    this.fetchPage(value);
  }

  onOwnerFilter(ownerId) {
    this.setState({ owner: ownerId }, () => this.fetchPage(1));
  }

  fetchPage(page) {
    const { q, unpaid, expert, custom, free, locked, owner, pageSize, lastFetchKey } = this.state;
    const safeParams = {
      q: q || '',
      page: page || 1,
      unpaid: !!unpaid,
      expert: !!expert,
      custom: !!custom,
      free: !!free,
      locked: !!locked,
      owner: owner || '',
      pageSize: pageSize || 30
    };
    const key = JSON.stringify(safeParams);
    if (lastFetchKey === key) {
      // Prevent duplicate fetch loops with identical params
      return;
    }

    this.setState({ isLoading: true, lastFetchKey: key });

    getWebsites(safeParams.q, safeParams.page, safeParams.unpaid, safeParams.expert, safeParams.custom, safeParams.free, safeParams.locked, safeParams.owner, safeParams.pageSize)
      .then((result) => {
        if (!this._isMounted) return;
        // sync URL query params for deep linking
        try {
          const params = {};
          if (safeParams.q) params.website_id = safeParams.q;
          if (safeParams.owner) params.owner = safeParams.owner;
          const query = qs.stringify(params, { addQueryPrefix: true });

          if (typeof window !== 'undefined') {
            // Under HashRouter, window.location.search is often empty because the query lives after the hash.
            // Compare against React Router's location.search to avoid triggering a replace on every fetch.
            const current = (this.props.location && this.props.location.search) ? this.props.location.search : '';
            if (current !== query) {
              if (this.props.history && this.props.history.replace) {
                this.props.history.replace({ search: query });
              } else {
                // Fallback (rare): try to preserve hash routing without causing loops
                const [hashPath] = (window.location.hash || '#').split('?');
                window.location.hash = `${hashPath}${query}`;
              }
            }
          }
        } catch (_) {}

        this.setState({
          hits: result.websites || [],
          page: parseFloat(result.page_nbr) || safeParams.page,
          total_elem: parseFloat(result.total_elem) || 0,
          isLoading: false,
          errorMsg: ''
        });
      })
      .catch((err) => this.setState({ isLoading: false, errorMsg: err?.message || 'Erreur lors du chargement des websites' }));
  }

  deleteReset(item) {
    reinitialiser(item._id).then(() => this.fetchPage(this.state.page));
  }

  deleteCancel(item) {
    deleteCustom(item._id).then(() => this.fetchPage(this.state.page));
  }

  quotaLock(item) {
    lockQuota(item._id).then(() => this.fetchPage(this.state.page));
  }

  quotaUnlock(item) {
    unlockQuota(item._id).then(() => this.fetchPage(this.state.page));
  }

  // (B6_01 / D47) L'interrupteur « Illimité IA Enterprise » (modere.ai_allowed, B0_02) a été
  // retiré : un site sur mesure n'est plus jamais gaté et le quota IA ne lit plus ce flag — la
  // quantité d'analyses incluse au forfait se saisit sur la licence (Formlicence). Le champ en
  // base et la route API setAiAllowed sont conservés, sans effet.

  // Active/désactive la modération AUTONOME (auto-apply Enterprise, flag C5) via l'endpoint
  // super-admin (B4_01). La popin reste ouverte, on remplace
  // modalWebsite par la réponse serveur (website à jour) + on synchronise hits. Confirmation à
  // l'activation (→ true) : l'auto-apply supprime/masque des contenus sans revue humaine.
  toggleAiAutonomous(website, enabled) {
    if (enabled && !window.confirm("Activer la modération AUTONOME (auto-apply) pour ce site ? L'IA appliquera ses verdicts sans revue humaine.")) {
      return;
    }
    setAiAutonomous(website._id, enabled)
      .then((updated) => this.setState((prev) => ({
        modalWebsite: updated,
        aiAutonomousError: '',
        hits: (prev.hits || []).map(w => w._id === updated._id ? updated : w),
      })))
      .catch((err) => this.setState({ aiAutonomousError: err?.message || 'Erreur lors de la mise à jour de la modération autonome' }));
  }

  // Bascule le mode GraphDebate (forum/média) d'un site via l'endpoint super-admin (B0_02).
  // Capacité interne (EPIC D2) jamais pilotée par le client. Confirmation car le mode change
  // le comportement GraphDebate du tenant. Même pattern que toggleAiAutonomous : la popin reste
  // ouverte, on remplace modalWebsite par la réponse serveur (website à jour) + on synchronise hits.
  changeGraphdebateMode(website, mode) {
    const current = website?.graphdebate?.mode || 'forum';
    if (mode === current) return; // idempotent : pas de bascule sur le mode déjà courant
    const labels = { forum: 'Forum', media: 'Média' };
    if (!window.confirm(`Basculer ce site en mode « ${labels[mode] || mode} » ? (capacité interne — change le comportement GraphDebate du tenant)`)) {
      return;
    }
    setGraphdebateMode(website._id, mode)
      .then((updated) => this.setState((prev) => ({
        modalWebsite: updated,
        graphdebateModeError: '',
        hits: (prev.hits || []).map(w => w._id === updated._id ? updated : w),
      })))
      .catch((err) => this.setState({ graphdebateModeError: err?.message || 'Erreur lors du changement de mode GraphDebate' }));
  }

  openFullscreenFrame(url) {
    this.updateViewportHeight();
    this.setState((prev) => ({
      iframeOpen: true,
      iframeUrl: url,
      iframeLoading: true,
      iframeKey: prev.iframeKey + 1
    }));
  }

  closeFullscreenFrame() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateViewportHeight);
    }
    this.setState({ iframeOpen: false, iframeUrl: '', iframeLoading: false });
  }

  handleIframeLoad() {
    this.setState({ iframeLoading: false });
  }

  reloadIframe() {
    this.setState((prev) => ({ iframeLoading: true, iframeKey: prev.iframeKey + 1 }));
  }

  openSmallIframe(url) {
    this.setState((prev) => ({
      smallIframeOpen: true,
      smallIframeUrl: url,
      smallIframeLoading: true,
      smallIframeKey: prev.smallIframeKey + 1
    }));
  }

  closeSmallIframe() {
    this.setState({ smallIframeOpen: false, smallIframeUrl: '', smallIframeLoading: false });
  }

  handleSmallIframeLoad() {
    this.setState({ smallIframeLoading: false });
  }

  reloadSmallIframe() {
    this.setState((prev) => ({ smallIframeLoading: true, smallIframeKey: prev.smallIframeKey + 1 }));
  }

  updateViewportHeight() {
    if (typeof window !== 'undefined') {
      const h = window.innerHeight;
      // Expose une unité viewport fiable (1% de la hauteur)
      document.documentElement.style.setProperty('--vh', `${h * 0.01}px`);
      if (h && h !== this.state.viewportHeight) {
        this.setState({ viewportHeight: h });
      }
    }
  }

  measureAppBar() {
    const h = this.appBarRef?.current?.clientHeight;
    if (h && h !== this.state.appBarHeight) {
      this.setState({ appBarHeight: h });
    }
  }

  handleActionChange(item, value) {
    const resetSelect = () =>
      this.setState((prev) => ({ actionSelection: { ...prev.actionSelection, [item._id]: '' } }));
    const navigate = (path) => {
      if (this.props.history && this.props.history.push) this.props.history.push(path);
      else window.location.href = path;
    };

    switch (value) {
      // `iframe=sa` = « BO embarqué dans le super-admin » : le BO pose $rootScope.iframe_sa et applique sa mise en
      // page compacte (barre latérale masquée, `index.ejs` `iframe_wp || iframe_sa` — graphproject, 2026-09-28).
      // ⛔ Jamais `iframe=wp` : c'est le contexte de l'extension WordPress ($rootScope.isWordpress) — assistant à
      // 9 étapes, écrans Général/Synchronisation du plugin, sortie Installation WP — pour TOUT site ouvert ici
      // (2026-09-28 : un Google Sites présenté comme un site WordPress). Détail : DOCS/19 §« Aperçu » et CLAUDE.md.
      case 'gc':
        this.openFullscreenFrame(`${process.env.REACT_APP_DOMAIN}/admin/#/website/${item._id}/graphcomment?iframe=sa`);
        break;
      case 'gd':
        this.openFullscreenFrame(`${process.env.REACT_APP_DOMAIN}/admin/#/website/${item._id}/graphdebate?iframe=sa&tab=approved`);
        break;
      case 'licences':
        navigate(`/super-admin/Listlicence?website_id=${item._id}`);
        break;
      case 'ads':
        navigate(`/super-admin/Formpub?website_id=${item._id}`);
        break;
      case 'vip':
        navigate(`/super-admin/ListVip?website_id=${item._id}`);
        break;
      case 'addViews':
        navigate(`/super-admin/Views?website_id=${item._id}&add=true`);
        break;
      case 'removeViews':
        navigate(`/super-admin/Views?website_id=${item._id}`);
        break;
      case 'filterOwner':
        if (item.owner?._id) this.onOwnerFilter(item.owner._id);
        break;
      case 'reset':
        this.deleteReset(item);
        break;
      case 'cancelPlan':
        this.deleteCancel(item);
        break;
      case 'quotaLock':
        this.quotaLock(item);
        break;
      case 'quotaUnlock':
        this.quotaUnlock(item);
        break;
      default:
        break;
    }
    resetSelect();
  }

  handleViewModeChange(event, nextView) {
    if (nextView) this.setState({ viewMode: nextView });
  }

  toggleExpand(id) {
    this.setState((prev) => ({
      expanded: { ...prev.expanded, [id]: !prev.expanded[id] }
    }));
  }

  openWebsitePopin(item) {
    this.setState({ modalOpen: true, modalWebsite: item, modalTab: 'identity' });
  }

  closeWebsitePopin() {
    this.setState({ modalOpen: false, modalWebsite: null });
  }

  handleTabChange(event, value) {
    this.setState({ modalTab: value }, () => {
      if (value === 'fcm' && this.state.modalWebsite) {
        this.fetchFcmForWebsite(this.state.modalWebsite._id);
      }
    });
  }

  getPlanChipProps(item) {
    const rights = (item?.rights || '').toLowerCase();
    const planName = (item?.plan?.name || '').toLowerCase();
    const maxViews = Number(item?.plan?.meta?.max_views);
    const baseLabel = item?.plan?.name || rights || '—';

    // Enterprise: violet
    if (rights === 'enterprise' || planName.includes('enterprise')) {
      return { label: baseLabel || 'enterprise', color: undefined, sx: { bgcolor: '#8B5CF6', color: '#FFFFFF' } };
    }

    // Overrides par max_views
    if (maxViews === 1500000) {
      return { label: baseLabel, color: undefined, sx: { bgcolor: '#FEF08A', color: '#111827' } }; // jaune clair
    }
    if (maxViews === 5000000) {
      return { label: baseLabel, color: undefined, sx: { bgcolor: '#FB923C', color: '#111827' } }; // orange
    }

    // Mapping standard
    if (rights === 'free' || planName === 'free') {
      return { label: 'free', color: 'info' }; // bleu
    }
    if (rights === 'expert' || planName.startsWith('expert')) {
      return { label: item?.plan?.name || 'expert', color: 'warning' }; // jaune
    }
    if (rights === 'pro' || planName.startsWith('pro')) {
      return { label: item?.plan?.name || 'pro', color: undefined, sx: { bgcolor: '#FB923C', color: '#111827' } }; // orange
    }

    return { label: baseLabel, color: 'default' };
  }

  renderWebsiteCard(item) {
    const open = !!this.state.expanded[item._id];
    const rightsStr =
      item.rights === 'free'
        ? 'free'
        : item.rights === 'expert'
        ? `expert - ${item.plan ? item.plan.name : 'free'}`
        : `${item.rights || ''} - ${item.plan ? item.plan.name : 'free'}`;

    const planChip = this.getPlanChipProps(item);

    return (
      <Card key={item._id} variant="outlined" sx={{ mb: 2 }}>
        <CardHeader
          avatar={<Avatar src={item.owner ? (item.owner.picture || '') : ''} alt={item.owner ? (item.owner.username || '') : ''} />}
          title={
            <Typography variant="subtitle1" sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
              {item.name}
            </Typography>
          }
          subheader={
            <Stack direction="row" spacing={1} alignItems="center" sx={{ flexWrap: 'wrap' }}>
              <MuiLink component={RouterLink} to={`/super-admin/User?user_id=${item.owner ? item.owner._id : ''}`} underline="hover">
                {item.owner ? (item.owner.username || '') : ''}
              </MuiLink>
              <Chip size="small" label={planChip.label} color={planChip.color} sx={planChip.sx} />
              <Chip size="small" color={item.status === 'validated' ? 'success' : item.status === 'pending' ? 'warning' : 'default'} label={item.status} />
            </Stack>
          }
          action={
            <IconButton size="small" onClick={() => this.toggleExpand(item._id)} aria-label={open ? 'Réduire' : 'Développer'}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          }
        />
        <CardContent sx={{ pt: 0 }}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
            <Groups2Icon fontSize="small" />
            <Typography variant="subtitle2">Audience & Activité</Typography>
          </Stack>
          <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 1, flexWrap: 'wrap' }}>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <Groups2Icon fontSize="small" />
              <Typography variant="body2">{item.count?.authors || 0}</Typography>
            </Stack>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <ChatBubbleOutlineIcon fontSize="small" />
              <Typography variant="body2">{item.count?.comments || 0}</Typography>
            </Stack>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <LayersIcon fontSize="small" />
              <Typography variant="body2">{item.count?.threads || 0}</Typography>
            </Stack>
          </Stack>

          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
            <LibraryBooksIcon fontSize="small" />
            <Typography variant="subtitle2">Langues</Typography>
          </Stack>
          <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', mb: 1 }}>
            {(item.languages || []).slice(0, 3).map((lng) => (
              <Chip key={lng} size="small" label={lng} />
            ))}
            {((item.languages || []).length > 3) && <Chip size="small" label={`+${(item.languages || []).length - 3}`} />}
          </Stack>

          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
            <LinkIcon fontSize="small" />
            <Typography variant="subtitle2">Lien</Typography>
          </Stack>
          <Tooltip title={item.url || ''}>
            <MuiLink href={item.url} target="_blank" rel="noopener" underline="hover" sx={{ display: 'inline-block', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {item.url}
            </MuiLink>
          </Tooltip>

          {/* FCM Subscribers Panel (visible without expanding) */}
          <Paper variant="outlined" sx={{ p: 1.5, mt: 1 }}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ xs: 'flex-start', sm: 'center' }} justifyContent="space-between">
              <Stack direction="row" spacing={1} alignItems="center">
                <NotificationsActiveOutlinedIcon fontSize="small" />
                <Typography variant="subtitle2">Abonnés FCM</Typography>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                <Button size="small" variant="outlined" onClick={() => this.fetchFcmForWebsite(item._id)} disabled={this.state.fcmLoading[item._id] === true}>
                  {this.state.fcmLoading[item._id] ? 'Chargement…' : 'Charger'}
                </Button>
                <MuiLink component={RouterLink} to={`/super-admin/User?website_id=${item._id}`} underline="hover">
                  <PersonSearchIcon fontSize="small" sx={{ mr: 0.5 }} /> Voir utilisateurs
                </MuiLink>
              </Stack>
            </Stack>
            {this.state.fcmError[item._id] && (
              <Typography variant="body2" color="error" sx={{ mt: 1 }}>{this.state.fcmError[item._id]}</Typography>
            )}
            {this.state.fcmSubs[item._id] && (
              <Box sx={{ mt: 1 }}>
                <Typography variant="body2">Count: <b>{this.state.fcmSubs[item._id].count}</b></Typography>
                <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', mt: 1 }}>
                  {this.state.fcmSubs[item._id].users.slice(0, 10).map((uid) => (
                    <Chip key={uid} label={uid} variant="outlined" onClick={() => navigator.clipboard?.writeText(uid)} onDelete={() => navigator.clipboard?.writeText(uid)} deleteIcon={<ContentCopyIcon fontSize="small" />} />
                  ))}
                  {this.state.fcmSubs[item._id].users.length > 10 && (
                    <Chip size="small" label={`+${this.state.fcmSubs[item._id].users.length - 10}`} />
                  )}
                </Stack>
              </Box>
            )}
          </Paper>

          <Collapse in={open} timeout="auto" unmountOnExit>
            <Divider sx={{ my: 1 }} />

            <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
              <TableChartIcon fontSize="small" />
              <Typography variant="subtitle2">Identifiants & Dates</Typography>
            </Stack>
            <Stack direction="column" spacing={1}>
              <Typography variant="caption" sx={{ fontFamily: 'monospace' }}>
                ID: {item._id}
              </Typography>
              <Typography variant="body2">Public key: {item.public_key}</Typography>
              <Typography variant="body2">Created: {item.created_at}</Typography>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 2 }}>
              <LibraryBooksIcon fontSize="small" />
              <Typography variant="subtitle2">Import</Typography>
            </Stack>
            <Stack direction="column" spacing={0.5}>
              <Typography variant="body2">date: {item.wp_import?.finish_date || ''}</Typography>
              <Typography variant="body2">batch: {item.wp_import?.batch_number || ''}</Typography>
              <Typography variant="body2">
                total comments: {item.wp_import?.nbr_comment_import || ''} / {item.wp_import?.total || ''}
              </Typography>
              <Typography variant="body2">status: {item.wp_import?.status || ''}</Typography>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 2 }}>
              <ViewModuleIcon fontSize="small" />
              <Typography variant="subtitle2">Options</Typography>
            </Stack>
            <Stack direction="column" spacing={0.5}>
              <Typography variant="body2">sso: {(item.sso?.active === true) ? 'active' : 'deactive'}</Typography>
              <Typography variant="body2">sso type: {item.sso ? (item.sso.unidirectional === true && item.sso.active === true ? 'unidirectional' : (item.sso.unidirectional === false && item.sso.active === true ? 'bidirectional' : '')) : ''}</Typography>
            </Stack>
          </Collapse>
        </CardContent>

        <CardActions sx={{ pt: 0, justifyContent: 'flex-end' }}>
          <FormControl size="small" variant="outlined" sx={{ minWidth: 200 }}>
            <InputLabel id={`actions-label-${item._id}`}>Actions</InputLabel>
            <Select
              labelId={`actions-label-${item._id}`}
              label="Actions"
              value={this.state.actionSelection[item._id] || ''}
              onChange={(e) => this.handleActionChange(item, e.target.value)}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 'min(360px, calc((var(--vh, 1vh) * 100) - 96px))',
                    overflowY: 'auto'
                  }
                },
                anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
                transformOrigin: { vertical: 'top', horizontal: 'right' },
                marginThreshold: 0
              }}
            >
              <MenuItem value=""><em>Actions</em></MenuItem>
              <ListSubheader>Navigation</ListSubheader>
              <MenuItem value="gc">Ouvrir GC</MenuItem>
              <MenuItem value="gd">Ouvrir GD</MenuItem>
              <MenuItem value="licences">Voir licences</MenuItem>
              <ListSubheader>Gestion</ListSubheader>
              <MenuItem value="ads">Update Ads</MenuItem>
              <MenuItem value="vip">VIP</MenuItem>
              <MenuItem value="addViews">Ajouter views</MenuItem>
              <MenuItem value="removeViews">Enlever views</MenuItem>
              <ListSubheader>Maintenance</ListSubheader>
              <MenuItem value="reset">Réinitialiser</MenuItem>
              <MenuItem value="cancelPlan">Annuler plan</MenuItem>
              <ListSubheader>Quota</ListSubheader>
              <MenuItem value="quotaLock">Bloquer quota</MenuItem>
              <MenuItem value="quotaUnlock">Débloquer quota</MenuItem>
              {item.owner?._id && (
                <>
                  <ListSubheader>Filtrage</ListSubheader>
                  <MenuItem value="filterOwner">Par propriétaire</MenuItem>
                </>
              )}
            </Select>
          </FormControl>
        </CardActions>
      </Card>
    );
  }

  render() {
    const { hits, page, total_elem, isLoading, q, unpaid, expert, custom, free, locked, expanded, pageSize, owner } = this.state;
    const pageCount = Math.max(1, Math.ceil((total_elem || 0) / (pageSize || 30)));

    return (
      <Box sx={{ p: 2 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'stretch', sm: 'center' }} justifyContent="space-between" sx={{ mb: 2 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="h6">Communautés</Typography>
            <Chip size="small" label={`Total: ${total_elem || 0}`} />
          </Stack>

          <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%', justifyContent: { xs: 'space-between', sm: 'flex-end' } }}>
            <Box component="form" onSubmit={this.onSearchSubmit} sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
              <TextField
                size="small"
                placeholder="Recherche par website_id ou mot-clé…"
                value={q}
                onChange={(e) => this.setState({ q: e.target.value })}
                sx={{ minWidth: { xs: '100%', sm: 280 } }}
                InputProps={{
                  endAdornment: q ? (
                    <IconButton size="small" onClick={() => this.setState({ q: '' }, () => this.fetchPage(1))} aria-label="Effacer">×</IconButton>
                  ) : null
                }}
                helperText="Astuce: utilisez ?website_id= et ?owner= dans l'URL pour partager une vue"
              />
              <TextField
                size="small"
                placeholder="Owner ID"
                value={owner}
                onChange={(e) => this.setState({ owner: e.target.value })}
                sx={{ minWidth: { xs: '100%', sm: 200 } }}
              />
              <FormControl size="small" sx={{ minWidth: 90 }}>
                <Select
                  value={pageSize || 30}
                  onChange={(e) => this.setState({ pageSize: Number(e.target.value) }, () => this.fetchPage(1))}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={30}>30</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
              <FormControlLabel control={<Checkbox checked={unpaid} onChange={(e) => this.setState({ unpaid: e.target.checked })} />} label="Unpaid" />
              <FormControlLabel control={<Checkbox checked={expert} onChange={(e) => this.setState({ expert: e.target.checked })} />} label="Expert" />
              <FormControlLabel control={<Checkbox checked={custom} onChange={(e) => this.setState({ custom: e.target.checked })} />} label="Custom" />
              <FormControlLabel control={<Checkbox checked={free} onChange={(e) => this.setState({ free: e.target.checked })} />} label="Free" />
              <FormControlLabel control={<Checkbox checked={locked} onChange={(e) => this.setState({ locked: e.target.checked })} />} label="Locked" />
              <Button type="submit" variant="contained" size="small">Rechercher</Button>
              <Button type="button" variant="text" size="small" onClick={() => this.setState({ q: '', owner: '', unpaid: false, expert: false, custom: false, free: false, locked: false }, () => this.fetchPage(1))}>Réinitialiser</Button>
            </Box>

          </Stack>
        </Stack>

        {this.state.errorMsg && (
          <Alert severity="error" sx={{ mb: 1 }} onClose={() => this.setState({ errorMsg: '' })}>
            {this.state.errorMsg}
          </Alert>
        )}
        {isLoading && <LinearProgress sx={{ mb: 1 }} />}

        {/* Liste uniquement en tableau */}
        {false ? (
          <>
            <Grid container spacing={2}>
              {hits.map((item) => (
                <Grid key={item._id} item xs={12} sm={6} md={4} lg={3}>
                  {this.renderWebsiteCard(item)}
                </Grid>
              ))}
            </Grid>

            <Box sx={{ px: 1.5, py: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography variant="caption" color="text.secondary">Page {page} / {pageCount}</Typography>
              <Stack direction="row" spacing={1} alignItems="center">
                <FormControl size="small" sx={{ minWidth: 80 }}>
                  <Select
                    value={pageSize || 30}
                    onChange={(e) => this.setState({ pageSize: Number(e.target.value) }, () => this.fetchPage(1))}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
                <Pagination
                  page={page}
                  count={pageCount}
                  onChange={this.onPageChange}
                  size="small"
                  color="primary"
                  showFirstButton
                  showLastButton
                  siblingCount={0}
                  boundaryCount={1}
                />
              </Stack>
            </Box>
          </>
        ) : (
          <Paper variant="outlined">
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Identifiants</TableCell>
                    <TableCell>Créé le</TableCell>
                    <TableCell>Statut</TableCell>
                    <TableCell>Plan</TableCell>
                    <TableCell>Nom</TableCell>
                    <TableCell>Activité</TableCell>
                    <TableCell>Url</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isLoading && hits.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">Chargement…</TableCell>
                    </TableRow>
                  ) : (
                    hits.map((item) => {
                      const locked = (item && item?.locked === true) ? true : false;
                      // Statut « site actif » : dernier chargement RÉEL du widget servi par l'API
                      // (`last_load_at`), jamais l'URL déclarée ni les compteurs (import WP).
                      const activity = websiteActivity(item.last_load_at);
                      const activityTitle = activity.state === 'unknown'
                        ? 'Dernier chargement non servi par cette version de l’API'
                        : item.last_load_at
                          ? `Dernier chargement du widget : ${moment(item.last_load_at).format('DD/MM/YYYY')} (actif = chargé depuis ≤ ${ACTIVE_WINDOW_DAYS} j, à ± 1 j près)`
                          : 'Aucun chargement du widget enregistré (tag jamais installé, ou fiche créée sans installation)';
                      return (
                        <TableRow key={item._id} hover sx={{ cursor: 'pointer' }} onClick={() => this.openWebsitePopin(item)}>
                          {/* Identifiants: ID + public key compact */}
                          <TableCell sx={{ width: { xs: 220, md: 320 }, maxWidth: { xs: 220, md: 320 } }}>
                            <Tooltip title={item._id}>
                              <Typography variant="body2" sx={{ fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
                                {item._id}
                              </Typography>
                            </Tooltip>
                            <Tooltip title={item.public_key || ''}>
                              <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'monospace', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                pk: {item.public_key}
                              </Typography>
                            </Tooltip>
                          </TableCell>

                          {/* Créé le — `created_at` servi par l'API, qui est aussi le tri par défaut
                              de la liste (`sort_field=created_at desc`) : sans cette colonne, l'ordre
                              des lignes n'était lisible qu'en décodant l'ObjectId. */}
                          <TableCell sx={{ width: { xs: 100, md: 110 }, whiteSpace: 'nowrap' }}>
                            <Tooltip title={item.created_at ? moment(item.created_at).format('DD/MM/YYYY HH:mm') : ''}>
                              <Typography variant="body2" data-testid="website-created-at">
                                {item.created_at ? moment(item.created_at).format('DD/MM/YYYY') : '—'}
                              </Typography>
                            </Tooltip>
                          </TableCell>

                          {/* Statut + Lock */}
                          <TableCell sx={{ width: { xs: 160, md: 200 } }}>
                            <Stack direction="row" spacing={1} alignItems="center" sx={{ flexWrap: 'wrap' }}>
                              <Chip size="small" label={item.status} color={item.status === 'validated' ? 'success' : item.status === 'pending' ? 'warning' : 'default'} />
                              <Chip size="small" label={locked ? 'Locked' : 'Unlocked'} color={locked ? 'warning' : 'default'} />
                            </Stack>
                          </TableCell>

                          {/* Plan */}
                          <TableCell sx={{ width: { xs: 120, md: 140 } }}>
                            <Chip size="small" {...this.getPlanChipProps(item)} />
                          </TableCell>

                          {/* Nom */}
                          <TableCell sx={{ maxWidth: { xs: 220, md: 260 } }}>
                            <Typography variant="body2" sx={{ fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {item.name}
                            </Typography>
                          </TableCell>

                          {/* Activité: site actif (dernier chargement réel du widget) + users / threads / comments */}
                          <TableCell sx={{ width: { xs: 220, md: 300 } }}>
                            <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'wrap' }}>
                              <Tooltip title={activityTitle}>
                                <Chip
                                  size="small"
                                  label={activity.label}
                                  color={activity.state === 'active' ? 'success' : activity.state === 'inactive' ? 'warning' : 'default'}
                                  variant={activity.state === 'never' ? 'outlined' : 'filled'}
                                  data-testid="website-activity"
                                  data-state={activity.state}
                                />
                              </Tooltip>
                              <Chip size="small" icon={<Groups2Icon sx={{ fontSize: 16 }} />} label={item.count?.authors || 0} variant="outlined" />
                              <Chip size="small" icon={<LayersIcon sx={{ fontSize: 16 }} />} label={item.count?.threads || 0} variant="outlined" />
                              <Chip size="small" icon={<ChatBubbleOutlineIcon sx={{ fontSize: 16 }} />} label={item.count?.comments || 0} variant="outlined" />
                            </Stack>
                          </TableCell>

                          {/* Url */}
                          <TableCell sx={{ maxWidth: { xs: 260, md: 360 } }}>
                            {(() => {
                              const addr = websiteAddress(item);
                              return (
                                <Tooltip title={addr.address}>
                                  <MuiLink href={addr.address || undefined} target="_blank" rel="noopener" underline="hover" onClick={(e) => e.stopPropagation()} data-testid="website-address" data-address-known="1" sx={{ display: 'inline-block', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {addr.address}
                                  </MuiLink>
                                </Tooltip>
                              );
                            })()}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>

              </Table>
            </TableContainer>

            <Box sx={{ px: 2, py: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography variant="caption" color="text.secondary">Page {page} / {pageCount}</Typography>
              <Stack direction="row" spacing={1} alignItems="center">
                <FormControl size="small" sx={{ minWidth: 80 }}>
                  <Select
                    value={pageSize || 30}
                    onChange={(e) => this.setState({ pageSize: Number(e.target.value) }, () => this.fetchPage(1))}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
                <Pagination
                  page={page}
                  count={pageCount}
                  onChange={this.onPageChange}
                  size="small"
                  color="primary"
                  showFirstButton
                  showLastButton
                  siblingCount={0}
                  boundaryCount={1}
                />
              </Stack>
            </Box>
          </Paper>
        )}

        <WebsitePurgeDialog
          open={Boolean(this.state.purgeWebsiteId)}
          websiteId={this.state.purgeWebsiteId}
          onClose={() => this.setState({ purgeWebsiteId: null })}
          onPurged={() => { this.closeWebsitePopin(); this.fetchPage(this.state.page); }}
        />

        {/* Popin d'informations du website */}
        <Dialog open={this.state.modalOpen} onClose={this.closeWebsitePopin} fullWidth maxWidth="lg">
          <DialogTitle>
            {this.state.modalWebsite ? `${this.state.modalWebsite.name || ''} — ${this.state.modalWebsite._id}` : 'Website'}
          </DialogTitle>
          <DialogContent dividers>
            <Box sx={{ position: 'sticky', top: 0, zIndex: 1, bgcolor: 'background.paper', mb: 1, mx: -3, mt: -1.5, px: 3, pt: 1.5, borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={this.state.modalTab} onChange={this.handleTabChange} variant="scrollable" allowScrollButtonsMobile aria-label="Onglets des informations du website">
                <Tab value="identity" label="Identity" />
                <Tab value="imports" label="Imports" />
                <Tab value="sso" label="SSO" />
                <Tab value="premium" label="Premium" />
                <Tab value="ads" label="Ads" />
                <Tab value="moderation" label="Moderation" />
                <Tab value="graphdebate" label="GraphDebate" />
                <Tab value="fcm" label="FCM" />
                <Tab value="vip" label="VIP" />
                <Tab value="invoices" label="Invoices" />
              </Tabs>
            </Box>

            {this.state.modalWebsite && (
              <Box sx={{ mt: 2 }}>
                {this.state.modalTab === 'identity' && (
                  <Stack spacing={1.5}>
                    <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
                      <Chip size="small" label={`Statut: ${this.state.modalWebsite.status || '—'}`} color={this.state.modalWebsite.status === 'validated' ? 'success' : this.state.modalWebsite.status === 'pending' ? 'warning' : 'default'} />
                      <Chip size="small" {...this.getPlanChipProps(this.state.modalWebsite)} />
                      <Chip size="small" label={(this.state.modalWebsite && this.state.modalWebsite.locked === true) ? 'Locked' : 'Unlocked'} color={(this.state.modalWebsite && this.state.modalWebsite.locked === true) ? 'warning' : 'default'} />
                      <Chip size="small" icon={<Groups2Icon sx={{ fontSize: 16 }} />} label={this.state.modalWebsite.count?.authors || 0} variant="outlined" />
                      <Chip size="small" icon={<LayersIcon sx={{ fontSize: 16 }} />} label={this.state.modalWebsite.count?.threads || 0} variant="outlined" />
                      <Chip size="small" icon={<ChatBubbleOutlineIcon sx={{ fontSize: 16 }} />} label={this.state.modalWebsite.count?.comments || 0} variant="outlined" />
                    </Stack>

                    <Stack spacing={0.5}>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>website_id:</Typography>
                        <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>{this.state.modalWebsite._id}</Typography>
                        <Tooltip title="Copier">
                          <IconButton size="small" onClick={() => navigator.clipboard?.writeText(this.state.modalWebsite._id)} aria-label="Copier l'ID">
                            <ContentCopyIcon fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>public_key:</Typography>
                        <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>{this.state.modalWebsite.public_key}</Typography>
                        <Tooltip title="Copier">
                          <IconButton size="small" onClick={() => navigator.clipboard?.writeText(this.state.modalWebsite.public_key)} aria-label="Copier la public key">
                            <ContentCopyIcon fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                      <Typography variant="body2"><b>name:</b> {this.state.modalWebsite.name}</Typography>
                      <Typography variant="body2"><b>owner:</b> {this.state.modalWebsite.owner ? `${this.state.modalWebsite.owner.username} (${this.state.modalWebsite.owner._id})` : ''}</Typography>
                      {(() => {
                        // Adresse déclarée (C9) : la fiche reçoit la ligne de liste, où `base_path` manque
                        // pour presque tout le parc → racine (D93). `base_path` brut affiché pour le support.
                        const addr = websiteAddress(this.state.modalWebsite);
                        return (
                          <>
                            <Typography variant="body2">
                              <b>url:</b>{' '}
                              {addr.address ? (
                                <MuiLink href={addr.address || undefined} target="_blank" rel="noopener" underline="hover" data-testid="website-address" data-address-known="1">
                                  {addr.address}
                                </MuiLink>
                              ) : '—'}
                            </Typography>
                            {addr.distinct && (
                              <Typography variant="body2" data-testid="website-base-path"><b>base_path:</b> {this.state.modalWebsite.base_path}</Typography>
                            )}
                          </>
                        );
                      })()}
                      <Typography variant="body2"><b>rights:</b> {this.state.modalWebsite.rights || '—'}</Typography>
                      <Typography variant="body2"><b>plan:</b> {this.state.modalWebsite.plan?.name || this.state.modalWebsite.rights || '—'}</Typography>
                      <Typography variant="body2"><b>plan max views:</b> {this.state.modalWebsite.plan?.meta?.max_views ?? '—'}</Typography>
                      <Typography variant="body2"><b>created_at:</b> {this.state.modalWebsite.created_at}</Typography>
                      {this.state.modalWebsite.updated_at && (
                        <Typography variant="body2"><b>updated_at:</b> {this.state.modalWebsite.updated_at}</Typography>
                      )}
                      <Typography variant="body2"><b>languages:</b> {(this.state.modalWebsite.languages || []).join(', ')}</Typography>
                    </Stack>

                    <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: 'wrap' }}>
                      <Button size="small" variant="outlined" component={RouterLink} to={`/super-admin/Listlicence?website_id=${this.state.modalWebsite._id}`} onClick={this.closeWebsitePopin}>Voir licences</Button>
                      <Button size="small" variant="outlined" color="warning" onClick={() => { this.deleteCancel(this.state.modalWebsite); this.closeWebsitePopin(); }}>Annuler le plan</Button>
                      <Button size="small" variant="outlined" color="warning" onClick={() => { this.quotaLock(this.state.modalWebsite); this.closeWebsitePopin(); }}>Bloquer quota</Button>
                      <Button size="small" variant="outlined" color="success" onClick={() => { this.quotaUnlock(this.state.modalWebsite); this.closeWebsitePopin(); }}>Débloquer quota</Button>
                      <Button size="small" variant="contained" onClick={() => this.openSmallIframe(`${process.env.REACT_APP_DOMAIN}/admin/#/website/${this.state.modalWebsite._id}/graphcomment?iframe=sa`)}>Ouvrir GC (popin)</Button>
                      <Button size="small" variant="contained" onClick={() => this.openSmallIframe(`${process.env.REACT_APP_DOMAIN}/admin/#/website/${this.state.modalWebsite._id}/graphdebate?iframe=sa&tab=approved`)}>Ouvrir GD (popin)</Button>
                      {/* Suppression INTÉGRALE (hosting-migration B2_09) — efface un site qui pollue la base.
                          ⛔ Autre usage que « Confirmer suppression communauté » (Deletewebsite), qui
                          anonymise et garde la donnée : deux boutons, ne pas les fusionner. */}
                      <Button size="small" variant="outlined" color="error" data-testid="website-purge-open" onClick={() => this.setState({ purgeWebsiteId: this.state.modalWebsite._id })}>Supprimer intégralement ce site</Button>
                    </Stack>
                  </Stack>
                )}

                {this.state.modalTab === 'imports' && (
                  <Stack spacing={1}>
                    <Typography variant="body2">date: {this.state.modalWebsite.wp_import?.finish_date || ''}</Typography>
                    <Typography variant="body2">batch_number: {this.state.modalWebsite.wp_import?.batch_number || ''}</Typography>
                    <Typography variant="body2">total import comment: {this.state.modalWebsite.wp_import?.nbr_comment_import || ''} / {this.state.modalWebsite.wp_import?.total || ''}</Typography>
                    <Typography variant="body2">status: {this.state.modalWebsite.wp_import?.status || ''}</Typography>
                    <Button size="small" variant="outlined" color="error" sx={{ mt: 1 }} onClick={() => { this.deleteReset(this.state.modalWebsite); }}>Réinitialiser</Button>
                  </Stack>
                )}

                {this.state.modalTab === 'sso' && (
                  <Stack spacing={1}>
                    <Typography variant="body2">sso: {(this.state.modalWebsite.sso?.active === true) ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">sso type: {this.state.modalWebsite.sso ? (this.state.modalWebsite.sso.unidirectional === true && this.state.modalWebsite.sso.active === true ? 'unidirectional' : (this.state.modalWebsite.sso.unidirectional === false && this.state.modalWebsite.sso.active === true ? 'bidirectional' : '')) : ''}</Typography>
                  </Stack>
                )}

                {this.state.modalTab === 'premium' && (
                  <Stack spacing={1}>
                    <Typography variant="body2">views: {this.state.modalWebsite.plan?.meta?.max_views ?? 1000000}</Typography>
                    <Typography variant="body2">rights: {this.state.modalWebsite.plan?.name || this.state.modalWebsite.rights}</Typography>
                    <Typography variant="body2">cgv version: {this.state.modalWebsite.cgv?.version || ''}</Typography>
                    <Typography variant="body2">custom enable: {(this.state.modalWebsite.plan?.meta?.enableCustom ?? 0) > 0 ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">custom client configuration: {this.state.modalWebsite.custom_client || 'none'}</Typography>
                    <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: 'wrap' }}>
                      <Button size="small" variant="outlined" component={RouterLink} to={`/super-admin/Views?website_id=${this.state.modalWebsite._id}&add=true`} onClick={this.closeWebsitePopin}>Ajouter views</Button>
                      <Button size="small" variant="outlined" component={RouterLink} to={`/super-admin/Views?website_id=${this.state.modalWebsite._id}`} onClick={this.closeWebsitePopin}>Enlever views</Button>
                    </Stack>
                  </Stack>
                )}

                {this.state.modalTab === 'ads' && this.state.modalWebsite && (
                  <Formpub location={{ search: `?website_id=${this.state.modalWebsite._id}` }} />
                )}

                {this.state.modalTab === 'moderation' && (
                  <Stack spacing={1}>
                    {this.state.aiAutonomousError && (
                      <Alert severity="error" onClose={() => this.setState({ aiAutonomousError: '' })}>
                        {this.state.aiAutonomousError}
                      </Alert>
                    )}
                    {/* B6_01 / D47 : plus d'interrupteur « Illimité IA Enterprise » — la quantité
                        d'analyses incluse au forfait se saisit sur la licence (Formlicence), et
                        un site sur mesure n'est jamais gaté. */}
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.modalWebsite.modere?.llm_ai_autonomous === true}
                          disabled={this.state.modalWebsite.rights !== 'custom'}
                          onChange={(e) => this.toggleAiAutonomous(this.state.modalWebsite, e.target.checked)}
                        />
                      }
                      label={`Modération autonome (Full AI)${this.state.modalWebsite.rights !== 'custom' ? ' (réservé Enterprise)' : ''}`}
                    />
                    {/* D14 — le régime RÉELLEMENT appliqué, à côté de l'interrupteur.
                        Sans ça, cette fiche dit « Modération autonome activée » pendant que
                        l'onglet « Config par site » dit « suggère seulement » pour le même
                        site : les deux sont vrais, un seul décrit ce que l'IA fait.
                        ⛔ La donnée ne peut PAS venir de CD2 : cet endpoint ne renvoie que les
                        sites qui ont consommé, alors que cette fiche s'ouvre sur n'importe
                        quel site, y compris dormant. Le régime est donc recalculé côté client
                        par le miroir documenté de `shouldApplyVerdicts` (lib/moderationModes). */}
                    <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
                      {/* L'ARMEMENT d'abord : sur un site dont l'IA est coupée, afficher un
                          régime sans le dire ferait lire « applique les verdicts » d'un moteur
                          qui n'analyse plus rien. Même hiérarchie que l'onglet « Config par
                          site » du dashboard, qui sépare armement et réglage. */}
                      {this.state.modalWebsite.modere?.llm_ai === true ? (
                        <Chip size="small" color="success" variant="outlined" label="IA active" />
                      ) : (
                        <Tooltip title="La modération IA est coupée sur ce site : le moteur ne l’analyse pas, quel que soit le réglage ci-dessous.">
                          <Chip size="small" color="default" variant="outlined" label="IA coupée" />
                        </Tooltip>
                      )}
                      <Tooltip title="Ce que l’IA fait réellement sur ce site aujourd’hui. L’interrupteur « Modération autonome » ne suffit pas à le dire : le mode « modération par vous » plafonne la clé, un site y reste en suggestion même armé.">
                        <Chip
                          size="small"
                          color={configRegime(this.state.modalWebsite.modere) === REGIME_APPLIED ? 'warning' : 'default'}
                          variant={configRegime(this.state.modalWebsite.modere) === REGIME_APPLIED ? 'filled' : 'outlined'}
                          label={`Réglage actuel : ${regimeLabel(configRegime(this.state.modalWebsite.modere))}`}
                        />
                      </Tooltip>
                      <Chip
                        size="small"
                        variant="outlined"
                        label={modeLabel(this.state.modalWebsite.modere?.llm_ai_type)}
                      />
                    </Stack>
                    <Divider />
                    {/* ⛔ `=== true`, et plus `!== false` (2026-09-21, remplace la lecture D14). Le
                        défaut du schéma api est repassé à `false` : un site SANS le champ n'est
                        PAS analysé par le moteur. D14 lisait « absent = actif » parce que le défaut
                        valait `true` — ce qui envoyait à l'analyse tout le parc qui n'avait rien
                        activé (c'était le bug). Cette fiche lit un website issu d'un `.aggregate()`
                        (aucun default Mongoose) : le champ y est `undefined`, jamais `false` —
                        d'où `=== true`, seul prédicat qui dise la même chose que le moteur ET que
                        `armed` du dashboard (api `moderation_dashboard_controller`). */}
                    <Typography variant="body2">llm_ai (modération LLM): {(this.state.modalWebsite.modere?.llm_ai === true) ? 'active' : 'deactive'}</Typography>
                    {/* Valeur BRUTE conservée : un site legacy y montre encore `ALL_AI`, et
                        c'est utile au support de voir la donnée telle qu'elle est en base.
                        Le mode en clair est au-dessus, normalisé (D29). */}
                    <Typography variant="body2">llm_ai_type: {this.state.modalWebsite.modere?.llm_ai_type || 'none'}</Typography>
                    <Typography variant="body2">llm_ai_usage: {this.state.modalWebsite.modere?.llm_ai_usage?.month ? `${this.state.modalWebsite.modere.llm_ai_usage.month} — ${this.state.modalWebsite.modere.llm_ai_usage.count || 0} analyses` : 'none'}</Typography>
                    <Divider />
                    <Typography variant="body2">Provider: {this.state.modalWebsite.modere?.provider || ''}</Typography>
                    <Typography variant="body2">smart auto delete: {(this.state.modalWebsite.modere?.smart?.auto_delete === true) ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">AiFilter: {(this.state.modalWebsite.modere?.ai === true) ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">SuggestAi: {(this.state.modalWebsite.modere?.suggest_ai === true) ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">Page: {(this.state.modalWebsite.modere?.page === true) ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">PageGroup: {(this.state.modalWebsite.modere?.page_group === true) ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">PageCommentGroup: {(this.state.modalWebsite.modere?.page_comment_group === true) ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">PageComment: {(this.state.modalWebsite.modere?.page_comment === true) ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">Comment: {(this.state.modalWebsite.modere?.comment === true) ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">Inbox: {(this.state.modalWebsite.modere?.inbox === true) ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">Thread: {(this.state.modalWebsite.modere?.thread === true) ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">Pseudo: {(this.state.modalWebsite.modere?.pseudo === true) ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">Avatar: {(this.state.modalWebsite.modere?.avatar === true) ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">Bio: {(this.state.modalWebsite.modere?.bio === true) ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">ProStatus: {(this.state.modalWebsite.modere?.pro_status === true) ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">twitterUsername: {(this.state.modalWebsite.modere?.twitter_username === true) ? 'active' : 'deactive'}</Typography>
                    <Typography variant="body2">Offense: {(this.state.modalWebsite.modere?.offense === true) ? 'active' : 'deactive'}</Typography>
                  </Stack>
                )}

                {this.state.modalTab === 'graphdebate' && this.state.modalWebsite && (
                  <Stack spacing={1.5}>
                    {this.state.graphdebateModeError && (
                      <Alert severity="error" onClose={() => this.setState({ graphdebateModeError: '' })}>
                        {this.state.graphdebateModeError}
                      </Alert>
                    )}
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>Mode :</Typography>
                      <Select
                        size="small"
                        value={this.state.modalWebsite.graphdebate?.mode || 'forum'}
                        onChange={(e) => this.changeGraphdebateMode(this.state.modalWebsite, e.target.value)}
                      >
                        <MenuItem value="forum">Forum</MenuItem>
                        <MenuItem value="media">Média</MenuItem>
                      </Select>
                    </Stack>
                    <Typography variant="body2" color="text.secondary">
                      Capacité interne (super-admin). « Média » active le mode média communautaire pour ce tenant ; « Forum » est le mode standard. Réservé à Semiologic — jamais exposé au client.
                    </Typography>
                  </Stack>
                )}

                {this.state.modalTab === 'fcm' && (
                  <Stack spacing={1}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <NotificationsActiveOutlinedIcon fontSize="small" />
                      <Typography variant="body2">Notifications push:</Typography>
                      {(() => {
                        const enabled = this.state.modalWebsite?.graphdebate?.push_broadcast_all;
                        const label = enabled === true ? 'Activées' : (enabled === false ? 'Désactivées' : 'Inconnu');
                        const color = enabled === true ? 'success' : (enabled === false ? 'error' : 'default');
                        return <Chip size="small" color={color} label={label} />;
                      })()}
                    </Stack>

                    {(() => {
                      const w = this.state.modalWebsite; const sid = w?._id; const loading = this.state.fcmLoading[sid]; const err = this.state.fcmError[sid]; const data = this.state.fcmSubs[sid];
                      if (loading) return <Typography variant="body2">Chargement des abonnés FCM…</Typography>;
                      if (err) return <Alert severity="error">{err}</Alert>;
                      return (
                        <Box>
                          <Typography variant="body2" sx={{ mb: 1 }}>Abonnés FCM: {data?.count ?? 0}</Typography>
                          {Array.isArray(data?.users) && data.users.length > 0 ? (
                            <Box sx={{ maxHeight: 300, overflow: 'auto' }}>
                              {data.users.map((u) => (
                                <Typography variant="body2" key={u}>{u}</Typography>
                              ))}
                            </Box>
                          ) : (
                            <Typography variant="body2">Aucun abonné.</Typography>
                          )}
                        </Box>
                      );
                    })()}
                  </Stack>
                )}

                {this.state.modalTab === 'vip' && this.state.modalWebsite && (
                  <Box sx={{ mt: 1 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={7}>
                        <ListVip websiteId={this.state.modalWebsite._id} />
                      </Grid>
                      <Grid item xs={12} md={5}>
                        <FormVip websiteId={this.state.modalWebsite._id} />
                      </Grid>
                    </Grid>
                  </Box>
                )}

                {this.state.modalTab === 'invoices' && this.state.modalWebsite && (
                  <Bills location={{ search: `?website=${this.state.modalWebsite._id}` }} />
                )}
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeWebsitePopin}>Fermer</Button>
          </DialogActions>
        </Dialog>

        {/* Popin iframe non-plein écran pour GC/GD */}
        <Dialog open={this.state.smallIframeOpen} onClose={this.closeSmallIframe} fullWidth maxWidth="xl">
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            {this.state.modalWebsite ? `Aperçu — ${this.state.modalWebsite.name}` : 'Aperçu'}
            <Box>
              <Tooltip title="Ouvrir dans un nouvel onglet">
                <IconButton onClick={() => window.open(this.state.smallIframeUrl, '_blank')} size="small" aria-label="Ouvrir dans un nouvel onglet" sx={{ mr: 0.5 }}>
                  <OpenInNewIcon />
                </IconButton>
              </Tooltip>
              <IconButton onClick={this.closeSmallIframe} size="small" aria-label="Fermer">
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ p: 0 }}>
            {this.state.smallIframeLoading && <LinearProgress />}
            <Box sx={{ height: '75vh' }}>
              <iframe
                key={this.state.smallIframeKey}
                title={this.state.modalWebsite ? `Aperçu ${this.state.modalWebsite.name}` : 'Aperçu'}
                src={this.state.smallIframeUrl}
                onLoad={this.handleSmallIframeLoad}
                style={{ border: 0, width: '100%', height: '100%' }}
              />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
              <Button size="small" startIcon={<RefreshIcon />} onClick={this.reloadSmallIframe} disabled={this.state.smallIframeLoading}>Recharger</Button>
            </Box>
          </DialogContent>
        </Dialog>

        <Dialog
          fullScreen
          open={this.state.iframeOpen}
          onClose={this.closeFullscreenFrame}
          TransitionComponent={Transition}
          TransitionProps={{
            onEntered: () => {
              this.measureAppBar();
              this.updateViewportHeight();
              if (typeof window !== 'undefined') window.addEventListener('resize', this.updateViewportHeight);
            },
            onExited: () => {
              if (typeof window !== 'undefined') window.removeEventListener('resize', this.updateViewportHeight);
            }
          }}
          PaperProps={{ sx: { display: 'flex', flexDirection: 'column' } }}
        >
          <AppBar ref={this.appBarRef} position="static" sx={{ boxShadow: 'none' }}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={this.closeFullscreenFrame} aria-label="Fermer">
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} variant="h6" component="div" title={this.state.iframeUrl}>
                {this.state.iframeUrl}
              </Typography>
              <Tooltip title="Recharger">
                <IconButton color="inherit" onClick={() => this.reloadIframe()} aria-label="Recharger">
                  <RefreshIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Ouvrir dans un nouvel onglet">
                <IconButton
                  color="inherit"
                  onClick={() => window.open(this.state.iframeUrl, '_blank')}
                  aria-label="Ouvrir dans un nouvel onglet"
                >
                  <OpenInNewIcon />
                </IconButton>
              </Tooltip>
            </Toolbar>
            {this.state.iframeLoading && <LinearProgress color="secondary" />}
          </AppBar>

          <Box
            sx={{
              width: '100%',
              height: `calc((var(--vh, 1vh) * 100) - ${this.state.appBarHeight}px)`,
              position: 'relative'
            }}
          >
            {this.state.iframeLoading && (
              <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1, bgcolor: 'rgba(255,255,255,0.5)' }}>
                <CircularProgress />
              </Box>
            )}
            <iframe
              key={this.state.iframeKey}
              title="preview"
              src={this.state.iframeUrl}
              onLoad={() => this.handleIframeLoad()}
              style={{ border: 0, width: '100%', height: '100%' }}
            />
          </Box>
        </Dialog>
      </Box>
    );
  }
}
export default Website;